import { NavLink } from 'react-router-dom';
import * as HeroIcons from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';

export const MenuItem = ({ name, description, href, icon, toggleDrawerFilters }) => {
    const IconComponent = HeroIcons[icon];

    const { requestStudentsPending, requestInvoicePending } = useSelector((state) => state.analytics);

    return (
        <NavLink
            to={`/${href}`}
            className="group relative flex gap-x-6 rounded-lg p-4 hover:bg-slate-100"
            onClick={() => toggleDrawerFilters()}
        >
            <div
                className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white"
            >
                <IconComponent
                    aria-hidden="true"
                    className="h-6 w-6 text-gray-600 group-hover:text-indigo-600"
                />
            </div>
            <div>
                <span
                    href={href}
                    className="font-semibold text-gray-900"
                >
                    {name}
                    {
                        (href === 'control-estudiantes' && requestStudentsPending > 0) && (
                            <span className='bg-red-500 absolute w-[20px] h-[20px] mt-[2px] ml-2 text-[.7rem] text-center text-white leading-5 rounded-[100%]'>{requestStudentsPending}</span>
                        )
                    }
                    {
                        (href === 'control-facturas' && requestInvoicePending > 0) && (
                            <span className='bg-red-500 absolute w-[20px] h-[20px] mt-[2px] ml-2 text-[.7rem] text-center text-white leading-5 rounded-[100%]'>{requestInvoicePending}</span>
                        )
                    }
                    <span className="absolute inset-0" />
                </span>
                <p className="mt-1 text-gray-600">{description}</p>
            </div>
        </NavLink>
    )
}
